import { useCurrentUserProfile } from "@/store/auth/userProfile.store";

export const useHasAuthRole = () => {
  const profile = useCurrentUserProfile((s) => s.user);
  return (
    profile.claims?.authRole === "partner" ||
    profile.claims?.authRole === "creator"
  );
};
